import GenerateAPI from '../generate.js'

const config = {
  list: {
    url: '/client/unnamed/payment/list',
    apiType: 'check',
  },
  submit: {
    url: '/client/unnamed/payment/submitOrder',
  },
  pay: {
    url: '/client/unnamed/payment/pay',
    apiType: 'check',
  },
  check: {
    url: '/client/unnamed/payment/pay/check',
    apiType: 'check',
  },
  submitData: {
    url: '/client/unnamed/payment/submit/data',
    apiType: 'check',
  },
  data: {
    url: '/client/unnamed/payment/toPay/data',
    apiType: 'check',
  },
  operate: {
    url: '/client/unnamed/payment/operate',
  },
  getOrderInfo: {
    url: '/client/unnamed/payment/getOrderInfoUnname',
    apiType: 'check',
  },
  getMaxCountTicketRemark: {
    url: '/client/unnamed/payment/getMaxCountTicketRemark',
    apiType: 'check',
  },
  getTicketTitleType: {
    url: '/client/unnamed/payment/getTicketTitleType',
    apiType: 'check',
  },

  checkUser: {
    url: '/client/unnamed/payment/checkUser',
    apiType: 'check',
  },
  getTempToken: {
    url: '/client/unnamed/payment/getTempToken',
    apiType: 'check',
  },
  getArrears: {
    url: '/client/unnamed/payment/getArrears',
    apiType: 'check',
  },
  checkPay2: {
    url: '/client/unnamed/payment/pay/check2',
    apiType: 'check',
  },
  submitOrder2: {
    url: '/client/unnamed/payment/submitOrder2',
    apiType: 'check',
  },
  checkRand: {
    url: '/client/unnamed/payment/checkRand',
    apiType: 'check',
  },
}

const apiAnonymousPay = GenerateAPI.generate(config)

export default apiAnonymousPay